import React from 'react'
const Software_Development = () => {
    return (
        <>
            <section className="web_development">
                <div className="container">
                    <div className="content">
                        <h2>Software</h2>
                        <h1>DEVELOPMENT</h1>
                    </div>
                </div>
            </section>
            <section className="web_development1">
                <div className="container py-5">
                    <div className="row d-flex align-items-center">
                        <div className="col-lg-8">
                            <div className="content">
                                <h2>Interactive Software Development Solutions</h2>
                                <p style={{ textAlign: "justify" }}>At Muhammad Rizwan, we focus on web designs that are functionality fast and seamlessly interactive for the critical audience of today and tomorrow. Our web development service focuses on building responsive interfaces to tame the increasing bounce rate of users. Our developers help businesses seize the digital footprint with optimized user-interaction and user-engagement for the critical audience of today and tomorrow. Our web development service focuses on building responsive interfaces to tame the increasing bounce rate of users.</p>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <img src="img/software-1.png" className='img-fluid' alt="Software-IMG" />
                        </div>
                    </div>
                </div>
            </section>
            <section className="web_development2">
                <div className="container">
                    <div className="content">
                        <h6>SERVICES</h6>
                        <h1>SEIZE THE GLOBAL REACH WITH<span style={{ color: "#30ADA7", fontFamily: "heading" }}>MUHAMMAD RIZWAN </span></h1>
                        <p>Many different types of software development. Often, the various kinds of AZ Solutions work together to bring your project to fruition.</p>
                    </div>
                </div>
            </section>
            <section className="web_development3">
                <div className="container">
                    <div className="row py-5">
                        <div className="col-lg-4 col-md-6 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/front-end.png" width={50} alt="frontend" /></center>
                                <h4 className='text-white py-1'>Frontend Development</h4>
                                <p style={{ textAlign: "justify" }}>Frontend developers work on the part of the product with which the user interacts. They are primarily concerned with the user interface (UI). For example, they might create the layout, visual aspects, and interactive elements of a website or app. However, their role isn’t identical to that of a UI or user experience (UX) designer. They also fix bugs and make certain that the UI can run on different browsers.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/backend.png" width={50} alt="backend" /></center>
                                <h4 className='text-white py-1'>Backend Development</h4>
                                <p style={{ textAlign: "justify" }}>In contrast, a backend developer works with the part of the product users can’t see — the back end. This professional builds the infrastructure that powers the website, app, or program, focusing on functionality, integration of systems, and core logic. They will also deal with the complex, underlying structure, ensuring strong performance, scalability, and security.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 my-2 d-flex align-items-stretch">
                            <div className="card p-3 text-center">
                                <center><img src="img/maintenance.png" width={50} alt="Full-stack" /></center>
                                <h4 className='text-white py-1'>Full-Stack Development</h4>
                                <p style={{ textAlign: "justify" }}>A full-stack developer works on all aspects of the product, including both the front and back ends. To be a successful full-stack developer, you must have strong programming skills, as well as a variety of soft skills that all tech professionals must have, such as problem-solving and critical thinking. At the end of the day, you — and perhaps your team — are responsible for creating a full, complete product.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Software_Development